export default __webpack_public_path__ + "static/memorial-day-sale-desktop-065b362259f123444635903c0761fa61.webp";